// extracted by mini-css-extract-plugin
export default {"container":"list_container__WqiD4","search":"list_search__WiFwO"};